module.exports = __webpack_public_path__ + "img/cooperative-group-man.315d130c.svg";